const CHUNK_RECOVERY_KEY = 'ml_chunk_recovery_state_v1';
const CHUNK_RECOVERY_WINDOW_MS = 5 * 60_000;
const CHUNK_RECOVERY_COOLDOWN_MS = 10_000;
const CHUNK_RECOVERY_MAX_ATTEMPTS = 2;


const getErrorMessage = (error) => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  return error.message || '';
};

export const isChunkLoadError = (error) => {
  const message = getErrorMessage(error);
  return (
    message.includes('ChunkLoadError')
    || message.includes('Loading chunk')
    || message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed')
    || message.includes('Failed to load module script')
    || message.includes("MIME type of 'text/html'")
  );
};

const parseRecoveryState = () => {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(CHUNK_RECOVERY_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.warn('mentalLoad: Konnte Chunk-Recovery-Status nicht lesen.', error);
    return null;
  }
};

const writeRecoveryState = (state) => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(CHUNK_RECOVERY_KEY, JSON.stringify(state));
};

const hasRecentRecoveryAttempt = (nowMs) => {
  const state = parseRecoveryState();
  if (!state?.attemptedAt) return false;
  return nowMs - Number(state.attemptedAt) < CHUNK_RECOVERY_COOLDOWN_MS;
};

const getAttemptsWithinWindow = (state, nowMs) => {
  if (!Array.isArray(state?.attempts)) return [];
  return state.attempts.filter((attempt) => nowMs - Number(attempt.at) < CHUNK_RECOVERY_WINDOW_MS);
};

export const recoverFromChunkLoadError = async (error, source = 'unknown') => {
  if (!isChunkLoadError(error)) return false;
  if (typeof window === 'undefined') return false;

  const nowMs = Date.now();
  const currentState = parseRecoveryState();
  const attemptsWithinWindow = getAttemptsWithinWindow(currentState, nowMs);

  if (attemptsWithinWindow.length >= CHUNK_RECOVERY_MAX_ATTEMPTS) {
    console.warn(`mentalLoad: Chunk-Recovery Limit erreicht (${source}).`);
    return false;
  }

  if (hasRecentRecoveryAttempt(nowMs)) {
    console.warn(`mentalLoad: Chunk-Recovery bereits kürzlich versucht (${source}).`);
    return false;
  }

  writeRecoveryState({
    attemptedAt: nowMs,
    source,
    attempts: [...attemptsWithinWindow, { at: nowMs, source }]
  });
  console.warn(`mentalLoad: Chunk-Fehler erkannt (${source}). Starte kontrollierte Recovery.`);

  const url = new URL(window.location.href);
  url.searchParams.set('__chunk_recover', String(nowMs));
  window.location.replace(url.toString());
  return true;
};
